/**
 * Оформление консоли. Значение живёт сразу в трёх местах, и это осознанно:
 *
 *   sessionStorage — чтобы применить мгновенно, не дожидаясь сокета;
 *   Mongo          — чтобы выбор пережил закрытие вкладки и переехал на
 *                    другое устройство вместе с ключом;
 *   SSR-документ   — чтобы первый кадр уже был в нужной теме. Без этого
 *                    страница успевает мигнуть светлым перед тем, как
 *                    JavaScript вспомнит про тёмное.
 */

export const THEMES = ['auto', 'light', 'dark'] as const;
export type Theme = (typeof THEMES)[number];

export const DEFAULT_THEME: Theme = 'auto';

export const THEME_LABELS: Record<Theme, string> = {
  auto: 'как в системе',
  light: 'светлая',
  dark: 'тёмная',
};

export function isTheme(value: unknown): value is Theme {
  return typeof value === 'string' && (THEMES as readonly string[]).includes(value);
}

/** Ключ в sessionStorage. Не localStorage: вкладка — естественная единица. */
export const THEME_SESSION_KEY = 'ebk.theme';

export interface Preferences {
  theme: Theme;
}

export const DEFAULT_PREFERENCES: Preferences = { theme: DEFAULT_THEME };
